import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import TrendingGrid from './components/TrendingGrid';
import CTASection from './components/CTASection';
import { getOrganizationSchema, getWebSiteSchema, getWebPageSchema, getFAQSchema } from '@/components/base/SchemaOrg';
import { categories } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

const faqList = [
  { question: '51吃瓜app是什么？', answer: '51吃瓜app是一个专注于娱乐八卦、网红爆料、明星黑料等热门资讯的聚合平台。我们实时汇聚全网最热门的吃瓜内容，为用户提供最新、最全、最快的娱乐资讯服务。' },
  { question: '51吃瓜app的内容来源是什么？', answer: '我们的内容来源于全网公开信息、用户投稿以及专业娱乐记者的一手报道。所有内容均经过编辑团队的审核与整理，确保信息的真实性和时效性。' },
  { question: '如何下载51吃瓜app？', answer: '您可以通过本网站提供的官方下载链接获取51吃瓜app。我们提供iOS和Android两个版本，请认准官方渠道下载。' },
  { question: '51吃瓜app是否收费？', answer: '51吃瓜app完全免费使用！我们不收取任何费用，所有内容均可免费浏览。' },
  { question: '如何投稿爆料？', answer: '如果您有独家爆料线索，欢迎通过网站底部的联系方式或App内的投稿通道向我们提供信息。我们承诺对投稿人信息严格保密。' },
];

export default function Home() {
  const orgSchema = getOrganizationSchema();
  const webSchema = getWebSiteSchema();
  const pageSchema = getWebPageSchema(
    '51吃瓜app - 全网最新吃瓜爆料视频 | 每日大赛黑料在线观看',
    '51吃瓜app提供全网最新吃瓜爆料视频在线观看，覆盖网红反差、博主塌房、明星聊天记录泄露等热门资源。51吃瓜app下载、入口、网站、最新地址一网打尽，每日大赛黑料不停！',
    'http://shlvtian.cn/'
  );
  const faqSchema = getFAQSchema(faqList);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }}
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />

          <section className="w-full py-8 md:py-12 px-4 md:px-6 bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-3 md:gap-4 overflow-x-auto pb-2 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to="/"
                    className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-100 text-foreground-700 text-sm rounded-full hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-sm`}></i>
                    </div>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <FeatureGrid />
          <TrendingGrid />
          <CTASection />
        </article>

        <section className="w-full py-10 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqList.map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-xl p-4 md:p-5 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm md:text-base font-medium text-foreground-900 list-none">
                    {faq.question}
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line text-foreground-500"></i>
                    </div>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      </main>

      <Footer />
    </>
  );
}